export const mutateListOnPost = (currentObjs, newObj) => ({
  content: Object.fromEntries([
    ...Object.entries(currentObjs.content),
    [newObj.id, newObj]
  ]),
  query: [...currentObjs.query, newObj.id]
});

export const mutateListOnPut = (currentObjs, updatedObj) => ({
  content: Object.fromEntries(
    Object.entries(currentObjs.content).map(([key, value]) =>
      key === updatedObj.id ? [key, updatedObj] : [key, value]
    )
  ),
  query: currentObjs.query
});

export const mutateListOnDelete = (currentObjs, deletedId) => ({
  content: Object.fromEntries(
    Object.entries(currentObjs.content).filter(([key]) => key !== deletedId)
  ),
  query: currentObjs.query.filter((id) => id !== deletedId)
});
